exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n  Project Colors\n */\n/**\n  Nav scss\n */\n:host {\n  display: block;\n  height: 50px; }\n\n.navbar-inverse .dropdown {\n  cursor: pointer; }\n\n.navbar-inverse .dropdown-menu {\n  background-color: #101010; }\n  .navbar-inverse .dropdown-menu li a {\n    color: #9d9d9d; }\n    .navbar-inverse .dropdown-menu li a:hover, .navbar-inverse .dropdown-menu li a:focus {\n      background-color: #010101; }\n\n.dropdown-menu > .active > a, .dropdown-menu > .active > a:hover, .dropdown-menu > .active > a:focus {\n  background-color: #333333; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/nav.component.scss
// module id = 388
// module chunks = 1